<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="col-4">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
        ></BrandDropdown>
      </div>
      <div class="col text-right align-self-end">
        <button
          @click="() => $router.push({ name: 'DetailPrivilegeCategory' })"
          class="btn btn-outline-primary"
        >
          Create
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span style="margin-right: 1rem">Show</span>
          <b-form-select
            class="form-control"
            style="width: 20%"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span style="margin-left: 1rem">entries</span>
        </div>
        <div class="d-flex align-items-center justify-content-end col">
          <label for="searchText" class="mx-3">Search: </label>
          <input
            id="searchText"
            type="text"
            v-model="searchText"
            class="form-control w-50"
            @change="getList"
          />
        </div>
      </div>
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listPrivileges"
        :per-page="perPage"
        @sort-changed="sortCompare"
        show-empty
      >
        <template #empty>
          <h1 class="text-center m-5">ไม่มีข้อมูลที่แสดง</h1>
        </template>
        <template #cell(dateCreated)="data">
          <div>{{ setFormatDate(data.item.dateCreated) }}</div>
        </template>
        <template #cell(lastUpdated)="data">
          <div>{{ setFormatDate(data.item.lastUpdated) }}</div>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailPrivilegeCategory',
                query: { id: data.item.id },
              }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import fields from "./fields.json";
import PrivilegeService from "services/api/privilegeCategory.service.js";
import BrandDropdown from "components/Brand/BrandDropdown";
import DefaultListViewData from "@/views/defaultListViewData";

export default {
  components: {
    BrandDropdown,
  },
  data() {
    return {
      ...DefaultListViewData,
      listPrivileges: [],
      fields,
      isSelectedBrand: false,
    };
  },
  mounted() {
    this.isLoading = true;
    this.getList(this.sort);
  },
  methods: {
    async getList(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage,
          brandCode: this.brandSelected?.id,
          sortColumn: sort.key || "id",
          sortType: sort.type || "desc",
          key: this.searchText,
        };
        await PrivilegeService.getListPrivilegeCategories(param)
          .then((res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.listPrivileges = data.privilegeCategorys;
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
      this.isSelectedBrand = this.brandSelected !== "";
      this.getList(this.sort);
    },
    sortCompare(e) {
      this.sort = {
        key: e.sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getList(this.sort);
    },
    changePage() {
      this.getList(this.sort);
    },
    onChangeEntries() {
      this.getList(this.sort);
    },
    setFormatDate(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
